module.exports = __webpack_public_path__ + "media/flags/ni-e68a107d.svg";